import { render, staticRenderFns } from "./mydocuments.vue?vue&type=template&id=c2526cea&scoped=true&"
import script from "./mydocuments.vue?vue&type=script&lang=js&"
export * from "./mydocuments.vue?vue&type=script&lang=js&"
import style0 from "./mydocuments.vue?vue&type=style&index=0&id=c2526cea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2526cea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2526cea')) {
      api.createRecord('c2526cea', component.options)
    } else {
      api.reload('c2526cea', component.options)
    }
    module.hot.accept("./mydocuments.vue?vue&type=template&id=c2526cea&scoped=true&", function () {
      api.rerender('c2526cea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/documents/mydocuments.vue"
export default component.exports